export const AUTH_STORAGE_KEY = "pd-auth";
